<template>
  <div>
    <div class='i-empty-panel text-center'>
      <img :src='imgURL' />
      <h1 class='i-panel-empty-msg'>{{ msg }}</h1>
    </div>
    <div v-if='showFooter' class='footer'></div>
  </div>
</template>

<script>
const imgMap = {
  empty: 'no_items_found',
  noFocus: 'edit_item',
};

export default {
  props: {
    msg: String,
    img: {
      type: String,
      default: 'empty',
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    imgURL() {
      const img = imgMap[this.img];
      return `/imperia/images/undraw/${img}.svg`;
    },
  },
};
</script>

<style scoped lang='scss'>
.i-empty-panel {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 50px));
}

.i-panel-empty-msg {
  color: #6b6b6b;
}
</style>
